import { createSlice } from "@reduxjs/toolkit";


// returns dev, beta, gamma, prod
const currentStage = 'prod';
let currentAppId = ''
let currentAppPage = 'Home'
let isCurrentAppAuthorized = null
let isPortalAdmin = false
let isSupportAdmin = false
let corpReportingQuarter = false
let userId = ''
let userCC = ''
let userFN = ''
let userEmail = ''
let loginRedirectPath = null
let organization = null
let userLDAPS = ''
let screenWidth = window.innerWidth
let isCorpReportingAdmin = false

const initialState = {
    userId,
    userCC,
    userFN,
    userEmail,
    currentStage,
    currentAppId,
    currentAppPage,
    isCurrentAppAuthorized,
    isPortalAdmin,
    isSupportAdmin,
    corpReportingQuarter,
    loginRedirectPath,
    organization,
    userLDAPS,
    screenWidth,
    isCorpReportingAdmin,
}

const userAuthSlice = createSlice({
    'name': 'userAuth',
    initialState,
    reducers: {
        setCurrentAppId(state, action) {
            state.currentAppId = action.payload
        },
        setTemplateId(state, action) {
            state.templateId = action.payload
        },
        setCurrentAppPage(state, action) {
            state.currentAppPage = action.payload
        },
        setCurrentAppAuthorization(state, action) {
            state.isCurrentAppAuthorized = action.payload
        },
        setCurrentUserId(state, action) {
            state.userId = action.payload
        },

        setCurrentFullName(state, action) {
            state.userFN = action.payload
        },

        setCurrentEmail(state, action) {
            state.userEmail = action.payload
        },
        setIsPortalAdmin(state, action) {
            state.isPortalAdmin = action.payload
        },
        setIsSupportAdmin(state, action) {
            state.isSupportAdmin = action.payload
        },
        setCorpReportingQuarter(state, action) {
            state.corpReportingQuarter = action.payload
        },
        setLoginRedirectPath(state, action) {
            state.loginRedirectPath = action.payload
        },
        setOrganization(state, action) {
            state.organization = action.payload
        },
        setCurrentUserLDAPS(state, action) {
            state.userLDAPS = action.payload
        },
        setScreenWidth(state, action) {
            state.screenWidth = action.payload
        },
        setIsCorpReportingAdmin(state, action) {
            state.isCorpReportingAdmin = action.payload
        }
    }
})

export const { setCurrentAppId, setCurrentAppPage, setCurrentAppAuthorization, setCurrentUserId, setCurrentFullName, setCurrentEmail, setIsPortalAdmin, setIsSupportAdmin, setTemplateId, setCorpReportingQuarter, setLoginRedirectPath, setOrganization, setScreenWidth, setCurrentUserLDAPS,setIsCorpReportingAdmin } = userAuthSlice.actions

export default userAuthSlice.reducer
